var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_large_share",
    "data-name": "icons / large / share",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-icon",
    transform: "translate(7.474 4.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,0V16.1H33.052V0",
    transform: "translate(0 23.814)",
    fill: "none",
    stroke: "#1a1919",
    strokeMiterlimit: 10,
    strokeWidth: 1.818
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_2",
    "data-name": "Stroke 2",
    d: "M.409,25.773V0",
    transform: "translate(13.091 0.952)",
    fill: "none",
    stroke: "#1a1919",
    strokeMiterlimit: 10,
    strokeWidth: 1.818
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_4",
    "data-name": "Stroke 4",
    d: "M0,12.812,13.453.088,13.547,0,27,12.724",
    fill: "none",
    stroke: "#1a1919",
    strokeMiterlimit: 10,
    strokeWidth: 1.818
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsShare);
export default __webpack_public_path__ + "static/media/icons_share.61ac2fa8.svg";
export { ForwardRef as ReactComponent };